import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { formFullDate } from '../../../../utils';
import Text from '../../../Basic/WrapsStyle/Text';
import TextGrey from '../../../Basic/WrapsStyle/TextGrey';
import Row from '../../../Basic/Blocks/Row';

const STATUS_MAP = {
  loading: 'выгружаю...',
  loaded: 'загружен',
  error: 'ошибка: ',
};

const ProviderUpdateStatusBlock = ({ providerId }) => {
  const [providerData, setProviderData] = useState({ stock_update: { status: '' } });
  const providers = useSelector((store) => store.providers);

  useEffect(() => {
    const item = providers.find((p) => p.id === providerId);
    if (item) {
      setProviderData(item);
    }
  }, [providerId, providers]);

  return (
    <Row style={{ marginTop: '10px' }}>
      <TextGrey style={{ marginRight: '10px' }} fontSize={'10px'}>
        Дата последнего обновления остатков:
      </TextGrey>
      <Text fontSize={'16px'}>
        {providerData.stock_update.status === 'loaded'
          ? `${formFullDate(providerData.stock_update.date)}  (${moment(providerData.stock_update.date).fromNow()}) `
          : STATUS_MAP[providerData.stock_update.status]}
        {providerData.stock_update.status === 'loading' &&
          ` ${Math.ceil((providerData.stock_update.done / providerData.stock_update.all) * 100)}%`}
        {providerData.stock_update.status === 'error' && ` ${providerData.stock_update.err_message}`}
      </Text>
    </Row>
  );
};

export default ProviderUpdateStatusBlock;
